import React from 'react'
import { Button, Flex, toast } from '@workwhile/ui'
import { parseErrorMessage } from 'api'
import {
  useDownloadInvoiceCsvMutation,
  useDownloadInvoicePdfMutation,
} from 'queries/admin/charges'

type InvoiceDownloadButtonsProps = {
  invoiceId: number
}

export const InvoiceDownloadButtons = ({
  invoiceId,
}: InvoiceDownloadButtonsProps) => {
  const csvMutation = useDownloadInvoiceCsvMutation()
  const pdfMutation = useDownloadInvoicePdfMutation()

  const handleDownloadCsv = () => {
    csvMutation.mutate(invoiceId, {
      onError: (error) => {
        toast.error(parseErrorMessage(error) ?? 'Failed to download CSV')
      },
    })
  }

  const handleDownloadPdf = () => {
    pdfMutation.mutate(invoiceId, {
      onError: (error) => {
        toast.error(parseErrorMessage(error) ?? 'Failed to download PDF')
      },
    })
  }

  return (
    <Flex alignItems="center" gap={2} flexWrap="wrap">
      <Button
        variant="secondary"
        kind="small"
        loading={csvMutation.isPending}
        disabled={pdfMutation.isPending}
        onClick={handleDownloadCsv}
      >
        Download CSV
      </Button>
      <Button
        variant="secondary"
        kind="small"
        loading={pdfMutation.isPending}
        disabled={csvMutation.isPending}
        onClick={handleDownloadPdf}
      >
        Download PDF
      </Button>
    </Flex>
  )
}
